import { Select } from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';
import { useLanguage, useTranslation } from '../../contexts/hooks';
import type { Language } from '../../contexts/translations';

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation();

  const languageOptions = [
    { value: 'en', label: t('language.english') },
    { value: 'fr', label: t('language.french') },
    { value: 'es', label: t('language.spanish') }
  ];

  return (
    <Select
      value={language}
      onChange={(value) => setLanguage(value as Language)}
      data={languageOptions}
      placeholder={t('language.select')}
      leftSection={<IconLanguage style={{ width: 16, height: 16 }} />}
      comboboxProps={{ withinPortal: true }}
      w={140}
      size="sm"
    />
  );
}